import React, { useEffect, useState } from 'react';
import { StopwatchIcon } from '~svg';
const CountDownTimer = ({
  direction,
  intl,
  showSearchTimeOut,
  closeTimeOut,
  isMobile = false,
}) => {
  const [expired, setExpired] = useState(false);
  let distance = 15,
    intervalId = 0;

  const ShowCountDown = () => {
    let searchDate = sessionStorage.getItem('searchTime');
    if (searchDate) {
      // Update the count down every 1 second
      if (distance > 0 && !expired) {
        intervalId = setInterval(() => {
          let countDownDate = new Date(searchDate).getTime() + 15 * 60 * 1000;
          // Get today's date and time
          let now = new Date().getTime();
          // Find the distance between now and the count down date
          distance = countDownDate - now;
          // Time calculations for hours, minutes and seconds
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);
          if (seconds < 10 && seconds.toString().length === 1)
            seconds = '0' + seconds;
          if (minutes < 10 && minutes.toString().length === 1)
            minutes = '0' + minutes;
          // Display the result in the element with id="countDown"
          let element = document.getElementById(
            `countDown-${isMobile ? 'mobile' : 'desktop'}`,
          );
          if (element && parseInt(minutes) >= 0 && parseInt(seconds) >= 0)
            element.innerHTML = minutes + ':' + seconds;
          // If the count down is finished, write some text
          if (distance <= 0) {
            setExpired(true);
          }
        }, 1000);
      }
    } else {
      setExpired(true);
    }
  };
  useEffect(() => {
    if (expired) {
      let element = document.getElementById(
        `countDown-${isMobile ? 'mobile' : 'desktop'}`,
      );
      if (element) {
        element.innerHTML = intl.formatMessage({
          id: 'booking.expirereserve',
        });
      }
      clearInterval(intervalId);
      showSearchTimeOut();
    }
  }, [expired]);
  useEffect(() => {
    ShowCountDown();
    return () => {
      distance = 15;
      clearInterval(intervalId);
    };
  });
  return (
    <>
      <StopwatchIcon size={20} color="#85cd95" />
      <span
        className="px-2 d-flex font-smaller font-xl-small"
        id={`countDown-${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          fontFamily: closeTimeOut
            ? direction === 'ltr'
              ? 'gotham'
              : 'vazir'
            : !expired
            ? 'digital'
            : direction === 'ltr'
            ? 'gotham'
            : 'vazir',
        }}
      ></span>
    </>
  );
};
export default CountDownTimer;
